// BCN Theme — theme.js

function bcnDebounce(fn, wait) {
  var t;
  return function() { clearTimeout(t); t = setTimeout(fn, wait); };
}

// Predictive-search fetch (shared by the header overlay and the search page).
// Returns rendered HTML from the predictive-search section.
function bcnFetchSuggest(query, signal) {
  var url = '/search/suggest?q=' + encodeURIComponent(query) +
            '&section_id=predictive-search' +
            '&resources[type]=product&resources[limit]=6';
  return fetch(url, { signal: signal }).then(function (r) { return r.text(); });
}

// Header height → CSS var (used for fixed header offset and mobile menu top)
(function () {
  var header = document.querySelector('.bcn-header');
  if (!header) return;
  function measure() {
    document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px');
  }
  measure();
  window.addEventListener('resize', bcnDebounce(measure, 150));
}());

// Footer nav: force columns open on desktop, collapsible on mobile
(function () {
  var details = document.querySelectorAll('details.bcn-footer__col');
  if (!details.length) return;

  function updateFooter() {
    var isDesktop = window.matchMedia('(min-width: 769px)').matches;
    details.forEach(function (d) {
      var summary = d.querySelector('summary');
      if (isDesktop) {
        d.setAttribute('open', '');
        if (summary) summary.style.pointerEvents = 'none';
      } else {
        d.removeAttribute('open');
        if (summary) summary.style.pointerEvents = '';
      }
    });
  }

  updateFooter();
  window.addEventListener('resize', bcnDebounce(updateFooter, 150));
}());

// Hamburger / mobile menu
(function () {
  var btn = document.querySelector('.bcn-nav__hamburger');
  var menu = document.getElementById('bcn-mobile-menu');
  var overlay = document.getElementById('bcn-mobile-overlay');
  if (!btn || !menu) return;

  var scrollY = 0;

  function lockScroll() {
    scrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + scrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.overflow = 'hidden';
  }

  function unlockScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.overflow = '';
    window.scrollTo(0, scrollY);
  }

  function closeMenu() {
    btn.setAttribute('aria-expanded', 'false');
    btn.classList.remove('is-open');
    menu.hidden = true;
    menu.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.hidden = true;
    unlockScroll();
  }

  btn.addEventListener('click', function () {
    var isOpen = btn.getAttribute('aria-expanded') === 'true';
    if (isOpen) {
      closeMenu();
    } else {
      btn.setAttribute('aria-expanded', 'true');
      btn.classList.add('is-open');
      menu.hidden = false;
      menu.setAttribute('aria-hidden', 'false');
      if (overlay) overlay.hidden = false;
      lockScroll();
    }
  });

  if (overlay) overlay.addEventListener('click', closeMenu);

  menu.querySelectorAll('a').forEach(function (link) {
    link.addEventListener('click', function () { closeMenu(); });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !menu.hidden) {
      closeMenu();
      btn.focus();
    }
  });

  window.addEventListener('resize', bcnDebounce(function () {
    if (window.innerWidth > 768 && !menu.hidden) { closeMenu(); }
  }, 150));
}());

// Testimonials carousel dots
(function () {
  var carousel = document.getElementById('bcn-reviews-carousel');
  if (!carousel) return;

  var dots = document.querySelectorAll('.carousel-dot');
  if (!dots.length) return;

  var cachedCard = null;
  function getCard() {
    if (!cachedCard) cachedCard = carousel.querySelector('.review');
    return cachedCard;
  }

  function updateDots() {
    var card = getCard();
    if (!card) return;
    var cardW = card.offsetWidth + 12; // gap
    var idx = Math.round(carousel.scrollLeft / cardW);
    dots.forEach(function (d, i) {
      d.classList.toggle('carousel-dot--active', i === idx);
      d.setAttribute('aria-selected', i === idx ? 'true' : 'false');
    });
  }

  var dotsTicking = false;
  carousel.addEventListener('scroll', function () {
    if (dotsTicking) return;
    dotsTicking = true;
    requestAnimationFrame(function () {
      updateDots();
      dotsTicking = false;
    });
  }, { passive: true });

  dots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      var card = getCard();
      if (!card) return;
      var cardW = card.offsetWidth + 12;
      carousel.scrollTo({ left: parseInt(dot.dataset.index) * cardW, behavior: 'smooth' });
    });
  });
}());

// Add to Cart via Shopify Cart API
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.btn-cart');
  if (!btn) return;

  var variantId = btn.dataset.variantId;
  if (!variantId) return;

  e.preventDefault();

  var originalText = btn.textContent.trim();
  btn.disabled = true;
  btn.textContent = 'Adding…';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
  })
    .then(function (res) {
      if (!res.ok) throw new Error('Cart error');
      return res.json();
    })
    .then(function () {
      btn.textContent = 'Added!';
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    })
    .then(function (res) { return res.json(); })
    .then(function (cart) {
      var countEl = document.querySelector('.cart-count');
      if (countEl) countEl.textContent = cart.item_count;
      setTimeout(function () {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 1500);
    })
    .catch(function () {
      btn.textContent = 'Error — try again';
      setTimeout(function () {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 2000);
    });
});

// Desktop mega menu
(function () {
  var megaBtn = document.querySelector('.bcn-nav__mega-btn');
  var megaPanel = document.getElementById('bcn-mega');
  if (!megaBtn || !megaPanel) return;

  function positionMega() {
    var header = document.querySelector('.bcn-header');
    if (header) {
      megaPanel.style.top = header.getBoundingClientRect().bottom + 'px';
    }
  }

  function openMega() {
    positionMega();
    megaBtn.setAttribute('aria-expanded', 'true');
    megaPanel.hidden = false;
    megaPanel.setAttribute('aria-hidden', 'false');
  }

  function closeMega() {
    megaBtn.setAttribute('aria-expanded', 'false');
    megaPanel.hidden = true;
    megaPanel.setAttribute('aria-hidden', 'true');
  }

  megaBtn.addEventListener('click', function () {
    if (megaBtn.getAttribute('aria-expanded') === 'true') {
      closeMega();
    } else {
      openMega();
    }
  });

  // Hover open on desktop (with grace-period timer so mouse can travel to panel)
  var hoverTimer;
  var isDesktop = function () { return window.matchMedia('(min-width: 769px)').matches; };
  var navItem = megaBtn.closest('.has-mega');
  if (navItem) {
    navItem.addEventListener('mouseenter', function () {
      if (!isDesktop()) return;
      clearTimeout(hoverTimer);
      openMega();
    });
    navItem.addEventListener('mouseleave', function () {
      if (!isDesktop()) return;
      hoverTimer = setTimeout(closeMega, 300);
    });
    megaPanel.addEventListener('mouseenter', function () {
      if (!isDesktop()) return;
      clearTimeout(hoverTimer);
    });
    megaPanel.addEventListener('mouseleave', function () {
      if (!isDesktop()) return;
      hoverTimer = setTimeout(closeMega, 300);
    });
  }

  document.addEventListener('click', function (e) {
    if (!megaPanel.hidden && !megaBtn.contains(e.target) && !megaPanel.contains(e.target)) {
      closeMega();
    }
  });

  megaPanel.querySelectorAll('a').forEach(function (a) {
    a.addEventListener('click', closeMega);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !megaPanel.hidden) {
      closeMega();
      megaBtn.focus();
    }
  });

  // Reposition on window resize in case header height changes
  window.addEventListener('resize', bcnDebounce(function () {
    if (!megaPanel.hidden) positionMega();
  }, 150));
}());

// Desktop inline expanding search (icon → bar slides open in the header)
(function () {
  var wrap = document.querySelector('[data-search]');
  if (!wrap) return;

  var toggle  = wrap.querySelector('[data-search-toggle]');
  var closeEl = wrap.querySelector('[data-search-close]');
  var input   = wrap.querySelector('.bcn-nav__search-input');
  var results = wrap.querySelector('.bcn-nav__search-results');
  if (!toggle || !input || !results) return;

  var controller = null;

  function openSearch() {
    wrap.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');
    input.removeAttribute('tabindex');
    if (closeEl) closeEl.removeAttribute('tabindex');
    input.focus();
  }

  function closeSearch() {
    wrap.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    input.setAttribute('tabindex', '-1');
    if (closeEl) closeEl.setAttribute('tabindex', '-1');
    results.innerHTML = '';
    results.classList.remove('is-visible');
    if (controller) { controller.abort(); controller = null; }
  }

  toggle.addEventListener('click', function () {
    if (wrap.classList.contains('is-open')) { closeSearch(); } else { openSearch(); }
  });
  if (closeEl) closeEl.addEventListener('click', closeSearch);

  // Close on Escape or click outside the search.
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && wrap.classList.contains('is-open')) { closeSearch(); toggle.focus(); }
  });
  document.addEventListener('click', function (e) {
    if (wrap.classList.contains('is-open') && !wrap.contains(e.target)) closeSearch();
  });

  var run = bcnDebounce(function () {
    var q = input.value.trim();
    if (q.length < 2) {
      results.innerHTML = '';
      results.classList.remove('is-visible');
      return;
    }
    if (controller) controller.abort();
    controller = new AbortController();
    bcnFetchSuggest(q, controller.signal)
      .then(function (html) {
        results.innerHTML = html;
        results.classList.add('is-visible');
      })
      .catch(function (err) {
        if (err.name !== 'AbortError') { results.innerHTML = ''; results.classList.remove('is-visible'); }
      });
  }, 250);

  input.addEventListener('input', run);
}());

// Predictive suggestions on the full search page (/search)
(function () {
  var input   = document.querySelector('.search-page__input');
  var suggest = document.querySelector('.search-page__suggest');
  if (!input || !suggest) return;
  var controller = null;

  function hide() { suggest.hidden = true; }

  var run = bcnDebounce(function () {
    var q = input.value.trim();
    if (q.length < 2) { suggest.innerHTML = ''; hide(); return; }
    if (controller) controller.abort();
    controller = new AbortController();
    bcnFetchSuggest(q, controller.signal)
      .then(function (html) {
        suggest.innerHTML = html;
        suggest.hidden = false;
      })
      .catch(function (err) { if (err.name !== 'AbortError') { suggest.innerHTML = ''; hide(); } });
  }, 200);

  input.addEventListener('input', run);
  input.addEventListener('focus', function () {
    if (input.value.trim().length >= 2 && suggest.innerHTML) suggest.hidden = false;
  });
  document.addEventListener('click', function (e) {
    if (e.target !== input && !suggest.contains(e.target)) hide();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') hide();
  });
}());

// Append a wildcard to search terms on submit so the results page does partial
// matching. Shopify storefront search needs "term*"; its options[prefix] param
// is ignored on this store. The displayed terms are stripped of "*" in Liquid.
(function () {
  function wildcard(q) {
    return q.trim().split(/\s+/).filter(Boolean).map(function (t) {
      return t.charAt(t.length - 1) === '*' ? t : t + '*';
    }).join(' ');
  }
  document.querySelectorAll('.bcn-nav__search-form, .search-page__form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var q = form.querySelector('input[name="q"]');
      if (!q || !q.value.trim()) return;
      // Navigate to the built URL instead of mutating the visible input, so the
      // "*" never flashes in the field. encodeURIComponent keeps "*" literal.
      e.preventDefault();
      var action = form.getAttribute('action') || '/search';
      window.location.href = action + '?q=' + encodeURIComponent(wildcard(q.value)) + '&type=product';
    });
  });
}());

// Mobile sub-menu (Shop All → collections)
(function () {
  var subBtn = document.querySelector('.bcn-mobile-menu__sub-btn');
  var subPanel = document.getElementById('bcn-mobile-sub');
  if (!subBtn || !subPanel) return;

  subBtn.addEventListener('click', function () {
    var isOpen = subBtn.getAttribute('aria-expanded') === 'true';
    subBtn.setAttribute('aria-expanded', String(!isOpen));
    subPanel.hidden = isOpen;
    subBtn.classList.toggle('is-open', !isOpen);
  });
}());

// ── PRODUCT PAGE ──
(function () {
  if (!document.querySelector('.prod-page')) return;

  var variants = window.BCN && window.BCN.productVariants ? window.BCN.productVariants : [];

  // ── Gallery ──
  var mainImg = document.getElementById('prod-main-img');
  var thumbs  = document.querySelectorAll('.prod-gallery__thumb');

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbs.forEach(function (t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-pressed', 'false');
      });
      thumb.classList.add('is-active');
      thumb.setAttribute('aria-pressed', 'true');
      if (mainImg && thumb.dataset.src) {
        mainImg.style.opacity = '0';
        setTimeout(function () {
          mainImg.src = thumb.dataset.src;
          mainImg.style.opacity = '1';
        }, 150);
      }
    });
  });

  // ── Quantity ──
  var qtyInput = document.getElementById('prod-qty');
  document.querySelectorAll('.prod-qty__btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var val = parseInt(qtyInput.value, 10) || 1;
      if (btn.dataset.action === 'plus') {
        qtyInput.value = val + 1;
      } else if (val > 1) {
        qtyInput.value = val - 1;
      }
    });
  });

  // ── Variant selection ──
  var selects   = document.querySelectorAll('.prod-option__select');
  var priceEl   = document.getElementById('prod-price');
  var compareEl = document.getElementById('prod-compare');
  var variantId = document.getElementById('prod-variant-id');
  var atcBtn    = document.getElementById('prod-atc');

  function matchVariant() {
    var selected = [];
    selects.forEach(function (sel) { selected.push(sel.value); });

    var match = variants.find(function (v) {
      return v.options.every(function (o, i) { return o === selected[i]; });
    });

    if (!match) return;

    variantId.value = match.id;

    var appstleWrap = document.getElementById('appstle_subscription_widget_container');
    if (appstleWrap) appstleWrap.setAttribute('data-variant-id', match.id);

    if (priceEl) {
      priceEl.textContent = formatMoney(match.price);
    }
    if (compareEl) {
      if (match.compare_at_price && match.compare_at_price > match.price) {
        compareEl.textContent = formatMoney(match.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
    if (atcBtn) {
      atcBtn.disabled = !match.available;
      atcBtn.setAttribute('aria-disabled', String(!match.available));
      atcBtn.textContent = match.available ? 'Add to Cart' : 'Sold Out';
    }
    if (match.featured_image && mainImg) {
      mainImg.style.opacity = '0';
      setTimeout(function () {
        mainImg.src = match.featured_image.src.replace(/\.jpg|\.png|\.webp/, function (ext) {
          return '_900x' + ext;
        });
        mainImg.style.opacity = '1';
      }, 150);
    }
  }

  // Size each option <select> to fit its selected value so the chevron stays
  // snug regardless of value length. Native selects size to their widest
  // option, and mobile browsers ignore text-align on selects — sizing the box
  // to the current value fixes both (alignment no longer matters).
  function sizeSelect(sel) {
    var opt = sel.options[sel.selectedIndex];
    if (!opt) return;
    var cs = getComputedStyle(sel);
    var meas = document.createElement('span');
    meas.style.cssText = 'position:absolute;visibility:hidden;white-space:pre;top:-9999px;left:-9999px';
    meas.style.fontFamily = cs.fontFamily;
    meas.style.fontSize = cs.fontSize;
    meas.style.fontWeight = cs.fontWeight;
    meas.style.letterSpacing = cs.letterSpacing;
    meas.style.textTransform = cs.textTransform;
    meas.textContent = opt.text;
    document.body.appendChild(meas);
    sel.style.width = (Math.ceil(meas.getBoundingClientRect().width) + 24) + 'px';
    document.body.removeChild(meas);
  }

  selects.forEach(function (s) {
    s.addEventListener('change', function () { sizeSelect(s); matchVariant(); });
    sizeSelect(s);
  });
  // Re-measure once fonts finish loading (initial measure can use a fallback).
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () { selects.forEach(sizeSelect); });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  // ── Accordion ──
  var triggers = document.querySelectorAll('.acc-trigger');

  triggers.forEach(function (trigger, i) {
    trigger.addEventListener('click', function () {
      var expanded  = trigger.getAttribute('aria-expanded') === 'true';
      var panelId   = trigger.getAttribute('aria-controls');
      var panel     = document.getElementById(panelId);

      // Close all others
      triggers.forEach(function (t) {
        var p = document.getElementById(t.getAttribute('aria-controls'));
        t.setAttribute('aria-expanded', 'false');
        if (p) p.classList.remove('is-open');
      });

      // Toggle this one
      if (!expanded) {
        trigger.setAttribute('aria-expanded', 'true');
        if (panel) panel.classList.add('is-open');
      }
    });

    // Keyboard: arrow keys navigate between triggers
    trigger.addEventListener('keydown', function (e) {
      var idx = Array.from(triggers).indexOf(trigger);
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        var next = triggers[idx + 1] || triggers[0];
        next.focus();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        var prev = triggers[idx - 1] || triggers[triggers.length - 1];
        prev.focus();
      } else if (e.key === 'Home') {
        e.preventDefault();
        triggers[0].focus();
      } else if (e.key === 'End') {
        e.preventDefault();
        triggers[triggers.length - 1].focus();
      }
    });
  });

}());

// Quick View drawer
(function () {
  var qv      = document.getElementById('bcn-qv');
  var qvPanel = document.getElementById('bcn-qv-panel');
  var qvBody  = document.getElementById('bcn-qv-body');
  var qvClose = document.getElementById('bcn-qv-close');
  var qvBack  = document.getElementById('bcn-qv-backdrop');
  if (!qv || !qvBody) return;

  var currentVariantId = null;

  function fmt(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function sizeSrc(url, size) {
    if (!url) return '';
    var parts = url.split('?');
    var qs = parts[1] ? '?' + parts[1] : '';
    return parts[0].replace(/(\.(jpe?g|gif|png|webp))$/i, '_' + size + '$1') + qs;
  }

  function openQV() {
    qv.hidden = false;
    qv.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        qv.classList.add('is-open');
      });
    });
  }

  function closeQV() {
    qv.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () {
      qv.hidden = true;
      qv.setAttribute('aria-hidden', 'true');
      qvBody.innerHTML = '<div class="qv__loading"><span>Loading…</span></div>';
    }, 360);
  }

  if (qvClose) qvClose.addEventListener('click', closeQV);
  if (qvBack)  qvBack.addEventListener('click', closeQV);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !qv.hidden) { closeQV(); }
  });

  function priceHTML(v) {
    if (v.compare_at_price && v.compare_at_price > v.price) {
      return '<span class="qv-price qv-price--sale">' + fmt(v.price) + '</span><span class="qv-compare">' + fmt(v.compare_at_price) + '</span>';
    }
    return '<span class="qv-price">' + fmt(v.price) + '</span>';
  }

  function buildQV(p) {
    var hasOptions = !(p.variants.length === 1 && p.variants[0].title === 'Default Title');
    var first = p.variants[0];
    currentVariantId = first.id;

    // Thumbnails
    var thumbsHtml = '';
    if (p.images.length > 1) {
      thumbsHtml = '<div class="qv-thumbs">';
      p.images.slice(0, 6).forEach(function (src, i) {
        thumbsHtml += '<button class="qv-thumb' + (i === 0 ? ' is-active' : '') + '" type="button" data-src="' + sizeSrc(src, '700x') + '" aria-label="Image ' + (i + 1) + '">'
          + '<img src="' + sizeSrc(src, '100x') + '" alt="" loading="lazy">'
          + '</button>';
      });
      thumbsHtml += '</div>';
    }

    // Options
    var optHtml = '';
    if (hasOptions) {
      optHtml = '<div class="qv-options">';
      p.options.forEach(function (optName, idx) {
        // Shopify may return option as string or {name,position} object
        var label = typeof optName === 'object' ? (optName.name || '') : optName;
        var values = [];
        p.variants.forEach(function (v) {
          var val = v['option' + (idx + 1)];
          if (val && values.indexOf(val) === -1) values.push(val);
        });
        var sel = first['option' + (idx + 1)];
        var valueOpts = values.map(function (val) {
          return '<option value="' + String(val).replace(/"/g, '&quot;') + '"' + (val === sel ? ' selected' : '') + '>' + val + '</option>';
        }).join('');
        optHtml += '<div class="prod-option">'
          + '<label class="prod-option__label" for="qv-opt-' + idx + '">' + label + '</label>'
          + '<div class="prod-option__select-wrap">'
            + '<select class="prod-option__select" id="qv-opt-' + idx + '" data-opt-idx="' + idx + '" aria-label="Select ' + label + '">' + valueOpts + '</select>'
            + '<svg class="prod-option__chevron" width="14" height="14" viewBox="0 0 256 256" fill="currentColor" aria-hidden="true"><path d="M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,53.66,90.34L128,164.69l74.34-74.35a8,8,0,0,1,11.32,11.32Z"/></svg>'
          + '</div></div>';
      });
      optHtml += '</div>';
    }

    var html = '';
    if (p.images.length) {
      html += '<div class="qv-img"><div class="qv-track" id="qv-track">';
      p.images.slice(0, 6).forEach(function (src) {
        html += '<div class="qv-slide"><img src="' + sizeSrc(src, '700x') + '" alt="' + p.title + '" loading="lazy"></div>';
      });
      html += '</div></div>';
    }
    html += thumbsHtml;
    html += '<h2 class="qv-title" id="bcn-qv-title">' + p.title + '</h2>';
    if (p._subtitle) {
      html += '<p class="qv-subtitle">' + p._subtitle + '</p>';
    }
    html += '<div class="qv-price-row" id="qv-price-row">' + priceHTML(first) + '</div>';
    html += optHtml;
    html += '<div class="qv-qty-row">'
      + '<span class="qv-qty-label">Qty</span>'
      + '<div class="qv-qty">'
      + '<button class="qv-qty__btn" type="button" data-action="minus" aria-label="Decrease quantity">−</button>'
      + '<input class="qv-qty__input" id="qv-qty" type="number" value="1" min="1" aria-label="Quantity">'
      + '<button class="qv-qty__btn" type="button" data-action="plus" aria-label="Increase quantity">+</button>'
      + '</div></div>';
    html += '<button class="qv-atc-btn" id="qv-atc" type="button"' + (!first.available ? ' disabled' : '') + '>'
      + (first.available ? 'Add to Cart' : 'Sold Out')
      + '</button>';
    html += '<a class="qv-full-link" href="' + p.url + '">View Full Details →</a>';

    return html;
  }

  function initQVEvents(p) {
    var atcBtn   = qvBody.querySelector('#qv-atc');
    var qtyInput = qvBody.querySelector('#qv-qty');
    var priceRow = qvBody.querySelector('#qv-price-row');

    // ── Image gallery: sliding track, thumbs, swipe, seamless loop ──
    var qvImg    = qvBody.querySelector('.qv-img');
    var track    = qvBody.querySelector('#qv-track');
    var slides   = track ? Array.from(track.children) : [];
    var thumbBtns = Array.from(qvBody.querySelectorAll('.qv-thumb'));
    var qvCurrent = 0;
    var qvN = slides.length;
    var qvPos = 0;
    var QV_TRANSITION = 'transform .3s cubic-bezier(.4, 0, .2, 1)';

    function normUrl(u) {
      return u ? u.split('?')[0].replace(/_(\d+)x(\d*)(\.(jpe?g|gif|png|webp))/i, '$4') : '';
    }
    function findImgIndex(url) {
      var base = normUrl(url);
      for (var i = 0; i < p.images.length && i < 6; i++) {
        if (normUrl(p.images[i]) === base) return i;
      }
      return -1;
    }

    if (track && qvN > 1) {
      // Clone first + last for an infinite loop
      var qvFirstClone = slides[0].cloneNode(true);
      var qvLastClone = slides[qvN - 1].cloneNode(true);
      qvFirstClone.setAttribute('aria-hidden', 'true');
      qvLastClone.setAttribute('aria-hidden', 'true');
      track.appendChild(qvFirstClone);
      track.insertBefore(qvLastClone, slides[0]);
      qvPos = 1;
    }
    function qvRender(animate) {
      if (!track) return;
      track.style.transition = animate ? QV_TRANSITION : 'none';
      track.style.transform = 'translateX(-' + (qvPos * 100) + '%)';
    }
    qvRender(false);
    function qvActiveThumb() {
      thumbBtns.forEach(function (t, i) { t.classList.toggle('is-active', i === qvCurrent); });
    }
    function qvNormalize() {
      if (qvPos === 0) { qvPos = qvN; qvRender(false); track.offsetHeight; }
      else if (qvPos === qvN + 1) { qvPos = 1; qvRender(false); track.offsetHeight; }
    }
    function qvStep(dir) {
      if (qvN < 2) return;
      qvNormalize();
      qvPos += dir;
      qvCurrent = (qvCurrent + dir + qvN) % qvN;
      qvRender(true);
      qvActiveThumb();
    }
    function qvGoTo(index) {
      if (qvN < 2) return;
      qvNormalize();
      qvCurrent = (index + qvN) % qvN;
      qvPos = qvCurrent + 1;
      qvRender(true);
      qvActiveThumb();
    }
    if (track) {
      track.addEventListener('transitionend', function () {
        if (qvPos === 0) { qvPos = qvN; qvRender(false); }
        else if (qvPos === qvN + 1) { qvPos = 1; qvRender(false); }
      });
    }
    thumbBtns.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { qvGoTo(i); });
    });

    // Touch drag — image follows finger, then snaps
    if (qvImg && qvN > 1) {
      var sx = 0, sy = 0, drag = false, lock = false, w = 0;
      qvImg.addEventListener('touchstart', function (e) {
        qvNormalize(); // never start a drag parked on a clone
        sx = e.touches[0].clientX; sy = e.touches[0].clientY;
        w = qvImg.offsetWidth; drag = true; lock = false;
      }, { passive: true });
      qvImg.addEventListener('touchmove', function (e) {
        if (!drag) return;
        var dx = e.touches[0].clientX - sx, dy = e.touches[0].clientY - sy;
        if (!lock) {
          if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
          lock = Math.abs(dx) > Math.abs(dy);
          if (!lock) { drag = false; return; }
        }
        if (e.cancelable) e.preventDefault(); // horizontal swipe — stop page scroll
        track.style.transition = 'none';
        track.style.transform = 'translateX(' + (-qvPos * w + dx) + 'px)';
      }, { passive: false });
      qvImg.addEventListener('touchend', function (e) {
        if (!drag) return;
        drag = false;
        if (!lock) return;
        var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > w * 0.15) { qvStep(dx < 0 ? 1 : -1); }
        else { qvRender(true); }
      }, { passive: true });
    }

    // Quantity stepper
    qvBody.querySelectorAll('.qv-qty__btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = btn.dataset.action === 'plus' ? v + 1 : Math.max(1, v - 1);
      });
    });

    // Variant selection
    var selected = [];
    p.options.forEach(function (_, i) { selected[i] = p.variants[0]['option' + (i + 1)] || null; });

    function matchVariant() {
      var match = null;
      for (var i = 0; i < p.variants.length; i++) {
        var v = p.variants[i];
        if (p.options.every(function (_, idx) { return v['option' + (idx + 1)] === selected[idx]; })) {
          match = v; break;
        }
      }
      if (!match) { match = null; for (var j = 0; j < p.variants.length; j++) { if (p.variants[j].available) { match = p.variants[j]; break; } } }
      if (!match) match = p.variants[0];

      currentVariantId = match.id;

      if (priceRow) priceRow.innerHTML = priceHTML(match);
      if (atcBtn) {
        atcBtn.disabled = !match.available;
        atcBtn.textContent = match.available ? 'Add to Cart' : 'Sold Out';
      }
      if (match.featured_image) {
        var idx = findImgIndex(match.featured_image.src);
        if (idx > -1 && idx !== qvCurrent) qvGoTo(idx);
      }
    }

    // Size each option <select> to fit its selected value so the chevron stays
    // snug (native selects size to the widest option; mobile ignores text-align).
    function qvSizeSelect(sel) {
      var opt = sel.options[sel.selectedIndex];
      if (!opt) return;
      var cs = getComputedStyle(sel);
      var meas = document.createElement('span');
      meas.style.cssText = 'position:absolute;visibility:hidden;white-space:pre;top:-9999px;left:-9999px';
      meas.style.fontFamily = cs.fontFamily;
      meas.style.fontSize = cs.fontSize;
      meas.style.fontWeight = cs.fontWeight;
      meas.style.letterSpacing = cs.letterSpacing;
      meas.style.textTransform = cs.textTransform;
      meas.textContent = opt.text;
      document.body.appendChild(meas);
      sel.style.width = (Math.ceil(meas.getBoundingClientRect().width) + 24) + 'px';
      document.body.removeChild(meas);
    }

    qvBody.querySelectorAll('.prod-option__select').forEach(function (selectEl) {
      selectEl.addEventListener('change', function () {
        var idx = parseInt(selectEl.dataset.optIdx, 10);
        selected[idx] = selectEl.value;
        qvSizeSelect(selectEl);
        matchVariant();
      });
      qvSizeSelect(selectEl);
    });

    // Add to cart
    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        if (!currentVariantId || atcBtn.disabled) return;
        var qty = parseInt(qtyInput ? qtyInput.value : 1, 10) || 1;
        var orig = atcBtn.textContent;
        atcBtn.disabled = true;
        atcBtn.textContent = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: currentVariantId, quantity: qty })
        })
          .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
          .then(function () {
            atcBtn.textContent = 'Added!';
            return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
          })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var countEl = document.querySelector('.cart-count');
            if (countEl) countEl.textContent = cart.item_count;
            setTimeout(function () { atcBtn.textContent = orig; atcBtn.disabled = false; }, 1600);
          })
          .catch(function () { atcBtn.textContent = orig; atcBtn.disabled = false; });
      });
    }
  }

  // Intercept "View Options" clicks
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.btn-qv');
    if (!btn) return;
    e.preventDefault();
    var handle = btn.dataset.handle;
    if (!handle) return;

    qvBody.innerHTML = '<div class="qv__loading"><span>Loading…</span></div>';
    openQV();

    var subtitle = btn.dataset.subtitle || '';
    fetch('/products/' + handle + '.js')
      .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function (product) {
        product._subtitle = subtitle;
        qvBody.innerHTML = buildQV(product);
        if (qvPanel) qvPanel.scrollTop = 0;
        initQVEvents(product);
      })
      .catch(function () {
        qvBody.innerHTML = '<div class="qv__loading" style="color:#e66"><span>Could not load product.</span></div>';
      });
  });
}());

// Collection row arrows (desktop) — scroll the product row by ~one card
(function () {
  document.querySelectorAll('.collection-row').forEach(function (row) {
    var scroller = row.querySelector('.collection-row__scroll');
    var arrows = row.querySelectorAll('.collection-row__arrow');
    if (!scroller || !arrows.length) return;

    function cardStep() {
      var card = scroller.querySelector('.prod-card');
      return card ? card.getBoundingClientRect().width + 12 : scroller.clientWidth * 0.8;
    }
    function update() {
      var maxScroll = scroller.scrollWidth - scroller.clientWidth - 2;
      arrows.forEach(function (a) {
        a.disabled = a.getAttribute('data-dir') === 'prev'
          ? scroller.scrollLeft <= 0
          : scroller.scrollLeft >= maxScroll;
      });
    }
    arrows.forEach(function (a) {
      a.addEventListener('click', function () {
        var dir = a.getAttribute('data-dir') === 'prev' ? -1 : 1;
        scroller.scrollBy({ left: dir * cardStep(), behavior: 'smooth' });
      });
    });
    scroller.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });
}());
